import { StatusData } from "@fairfleet/geotab";
import { GridColDef, GridRenderCellParams, GridRowModel } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CompactDiagnosticCell } from "../cells/CompactDiagnosticCell";
import { I18nGrid } from "@/components/data/I18nGrid";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { usePresetContext } from "@/components/PresetProvider";

interface Props {
  data: StatusData[];
}

export default function CompactDiagnostics({ data }: Props) {
  const { columnNames } = useDataGridSettings();
  const { selectedPreset: preset } = usePresetContext();
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { headerName: t("faultOverview.diagnostic"), flex: 1, field: "diagnostic", type: "string" },
    {
      field: "compact-diagnostic-value",
      flex: 0.5,
      headerName: t("faultOverview.diagnosticValue"),
      type: "number",
      renderCell: (params: GridRenderCellParams) => <CompactDiagnosticCell {...params} />,
    },
  ];
  const [rows, setRows] = useState<GridRowModel[]>([]);
  useEffect(() => {
    setRows(
      preset?.columns?.map(col => {
        return {
          id: col?.diagnostic?.id,
          diagnostic: columnNames?.[col?.diagnostic?.id] ?? col?.diagnostic?.name,

          // @ts-ignore
          "compact-diagnostic-value": data?.find(d => d?.diagnostic?.id === col?.diagnostic?.id),
        };
      }) ?? [],
    );
  }, [columnNames, data, preset]);

  return (
    <I18nGrid
      rows={rows ?? []}
      columns={columns}
      // sx={{
      //   maxHeight: "40vh",
      // }}
      density="compact"
      hideFooter
      disableAutosize
      disableColumnResize
      disableColumnPinning
      disableColumnReorder
      disableRowSelectionOnClick
    />
  );
}
